import React, { useState, useEffect } from 'react';
import {
  Modal,
  Button,
} from 'react-bootstrap';
import qs from 'qs';
import PropTypes from 'prop-types';

import { delay, getErrorMessage } from '../../../../../utils/helper';
import { changeOrderStatusUrl } from '../../../../../services/endpoints/orders';
import { STATUSES_NAMES } from '../../../constants';

import Loader from '../../../../../components/Loaders/Loader';
import ModalConfirm from '../../../../../components/Modal/ConfirmLayouts';

const ChangeStatusModal = ({ data, onHide, onSubmit }) => {
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({
    init: false,
    success: false,
    changeStatusTo: null,
    id: null,
  })
  const { id, success, changeStatusTo } = modalData;

  const queryString = qs.parse(window.location.search.slice(1));

  const changeStatusName = STATUSES_NAMES[changeStatusTo];

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const status = changeStatusTo.toLowerCase();
      const response = await changeOrderStatusUrl(queryString, data.id, status);
      setModalData((prevState) => ({
        ...prevState,
        success: true,
      }))
      await delay(500);
      onSubmit(response.data)
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setLoading(false);
    }
  };

  useEffect(() => {
    setModalData((prevState) => ({
      ...prevState,
      id: data?.id,
      changeStatusTo: data.changeStatusTo,
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ModalConfirm.Wrapper>
      <Modal.Body>
        <ModalConfirm.TitleDescriptionWrapper>
          {error ? <div className="alert alert-danger">{error}</div> : null}
          {isLoading ? <Loader success={success} /> : null }
          <ModalConfirm.Title>
            Change order status
            <div>
              (Order ID:
              {' '}
              {id}
              )
            </div>
          </ModalConfirm.Title>
          <ModalConfirm.Description>
            <div>
              Are you sure you want to change the order status to
              {' '}
              <b>{changeStatusName}</b>
              ?
            </div>
          </ModalConfirm.Description>
        </ModalConfirm.TitleDescriptionWrapper>
        <ModalConfirm.Actions>
          <Button
            type="button"
            bsStyle="primary"
            disabled={isLoading}
            onClick={onSubmitForm}
          >
            <span>Change</span>
          </Button>
          <Button
            disabled={isLoading}
            onClick={onHide}
          >
            <span>Close</span>
          </Button>
        </ModalConfirm.Actions>
      </Modal.Body>
    </ModalConfirm.Wrapper>
  );
};

ChangeStatusModal.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ChangeStatusModal;
